<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconKey_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M15.375 3C12.27 3 9.75 5.615 9.75 8.838c0 .374 0 .747.068 1.098L3 17.01v4.67h6.75v-4.67h4.5v-2.335l.068-.07c.337.07.697.07 1.057.07 3.105 0 5.625-2.615 5.625-5.838S18.48 3 15.375 3ZM16.5 5.335c1.238 0 2.25 1.051 2.25 2.335 0 1.285-1.012 2.336-2.25 2.336s-2.25-1.051-2.25-2.336c0-1.284 1.012-2.335 2.25-2.335Z"
    />
</svg>
